import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "q-pa-md",
  style: {"min-width":"500px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Modificare tip document", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "col-2 form__label" }, "Categorie", -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "col-2 form__label" }, "Tip", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "absolute-bottom-right q-pa-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_q_select, {
        class: "col-10",
        outlined: "",
        modelValue: _ctx.id_categ,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.id_categ) = $event)),
          _ctx.onValueChangeTipCategorie
        ],
        options: _ctx.optionsCategorii,
        style: {"max-height":"7vh"},
        "option-value": "appid",
        "option-label": "den_lang_1",
        "emit-value": "",
        "map-options": "",
        "lazy-rules": "",
        dense: "",
        "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' },
        rules: [ val => val && val > 0 || 'Alegeti categoria documentului!']
      }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "rules"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode(_component_q_select, {
        class: "col-10",
        outlined: "",
        modelValue: _ctx.id_tip_doc,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.id_tip_doc) = $event)),
          _ctx.onValueChangeTipDocument
        ],
        options: _ctx.filteredOptionTipDoc,
        style: {"max-height":"7vh"},
        "option-value": "appid",
        "option-label": "den_lang_1",
        "emit-value": "",
        "map-options": "",
        "lazy-rules": "",
        dense: "",
        "use-input": "",
        "input-debounce": "300",
        onFilter: _ctx.filterTipDocument,
        "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' },
        rules: [ val => val && val > 0 || 'Alegeti tipul documentului!']
      }, null, 8, ["modelValue", "options", "onFilter", "onUpdate:modelValue", "rules"])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_q_btn, {
        label: "Salveaza",
        size: "sm",
        color: "primary",
        onClick: _ctx.modificaTipDocument
      }, null, 8, ["onClick"]),
      _createVNode(_component_q_btn, {
        label: "Renunt",
        size: "sm",
        type: "reset",
        flat: "",
        onClick: _ctx.renuntModificareTipDoc,
        style: {"margin-left":"5px"}
      }, null, 8, ["onClick"])
    ])
  ]))
}